import { createRouter } from 'vue-router'
import { createWebHashHistory } from 'vue-router'
// component: () => import("@/views/Home.vue"), lazy loading saves size
const routes = [
  //{ path: '/', component: Home, name: "home"},
  // { path: '/about', component: About },
  
  // {
  //   path: "/help",
  //   name: "help",
  //   component: HelpView,
  // },
  {
    path: "/login/",
    name: "login",
    component: () => import("@/components/Login.vue"),
  },
  {
    path: "/",
    name: "collect",
    component: () => import("@/views/DataCollect.vue"),
  },
  // {
  //   path: "/scan/",
  //   name: "scan",
  //   component: () => import("@/views/Home.vue"),
  // },
   {
    path: "/summary",
    name: "Summary",
    component: () => import("@/views/Summary.vue"),
   },
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = createRouter({
  // 4. Provide the history implementation to use. We
  // are using the hash history for simplicity here.
  history: createWebHashHistory(),
  routes, // short for `routes: routes`
})
export default router
